import React, { PropsWithChildren } from "react";

import { cn } from "helpers/style";
import { capitalize } from "helpers/text";
import styles from "./Title.module.scss";

export type Props = PropsWithChildren<{
  size?: "h1" | "h2" | "h3";
  align?: "left" | "center" | "right";
  as?: string;
  className?: string;
}>;

const Title: React.FC<Props> = ({
  size,
  align,
  as,
  className,
  children,
}: Props) => {
  const element = as || "div";
  return React.createElement(
    element,
    {
      className: cn([
        styles.title,
        size && styles[`title${capitalize(size)}`],
        className,
      ]),
      style: align ? { textAlign: align } : {},
    },
    children
  );
};

export default Title;
